export default __webpack_public_path__ + "static/media/SpringFestival_09.96ffd89f.png";